<template>
	<header class="header" id="header">
		<nav class="navbar navbar-default margin_horizontal_20">
			<div class="navbar-header">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
					<span class="sr-only">昭君知产</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<div class="w3layouts-logo">
					<h1 class="logo_all"><a href="/index">昭君(北京)知识产权代理有限公司</a></h1>
					<h1 class="logo_short"><a href="/index">昭君知识产权</a></h1>
				</div>
			</div>
			<div class="collapse navbar-collapse nav-wil" id="bs-example-navbar-collapse-1">
				<nav>
					<ul class="nav navbar-nav">
						<li><a href="/index">首页</a></li>
						<li><a href="/index#services" class="scroll">服务项目</a></li>
						<!--<li><a href="/index#gallery" class="scroll">案例展示</a></li>  -->
						<li><a href="/index#FQA" class="scroll">常见问题</a></li>
						<li><a href="/index#news" class="scroll">新闻动态</a></li>
						<!-- <li><a href="/index#team" class="scroll">专业团队</a></li> -->
						<li><a href="/index#about" class="scroll">关于我们</a></li>
					</ul>
				</nav>
			</div>
		</nav>
	</header>
</template>

<script>
	export default {
		name: 'Header'
	}
</script>

<style>
	.header {
		position: relative;
		z-index: 100;
	}
</style>
